import React from 'react'

const StepsItem = ({ number, header, details }) => {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="item">
        <div className="number-border sm">
          <div className="number-step"><span>{number}</span></div>
        </div>
        <div className="name">{header}</div>
        <div className="content">
          {details}
        </div>
      </div>
    </div>
  )
}

export default StepsItem
